import HTMLReactParser from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';

const html = (htmlString: string) => {
  return HTMLReactParser(DOMPurify.sanitize(htmlString));
};

export default html;
